import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`

/* hind-regular - latin */
@font-face {
  font-family: 'Hind';
  font-style: normal;
  font-weight: 400;
  src: url('/fonts/hind-v10-latin-regular.eot'); /* IE9 Compat Modes */
  src: local('Hind Regular'), local('Hind-Regular'),
       url('/fonts/hind-v10-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
       url('/fonts/hind-v10-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
       url('/fonts/hind-v10-latin-regular.woff') format('woff'), /* Modern Browsers */
       url('/fonts/hind-v10-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
       url('/fonts/hind-v10-latin-regular.svg#Hind') format('svg'); /* Legacy iOS */
}


html,
body,
#root {
  /* height: 100%; */
  /* min-height: 100% !important; */
}

h1, h2, h3, h4, h5{
  margin: 0;
  padding: 0;
  /* font-family: 'Montserrat' */
  font-family: 'Hind', sans-serif;
}

body {
  background-color: #f4f4f4;
  font-family: 'Hind', sans-serif;
  /* font-size: 17px; */
  color: #4c4c4c;
}

a {
  /* color: #888; */
  color: ${props => props.theme.colors.primary};
  text-decoration: underline;
  /* font-weight: bold; */
}

a:hover {
  color: #ea1954;
}

/* react-modal adjustments */

.ReactModal__Html--open,
.ReactModal__Body--open {
  overflow: hidden; /* prevents background page from scrolling when the modal is open */
}

.ReactModal__Content {
  /* background: white; */
  /* width: 50rem; */
  max-width: calc(100vw - 2rem);
  max-height: calc(100vh - 2rem);
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  position: relative;
}

`;

export default GlobalStyle;
